import { useCallback } from 'react';
import { useLoginUserWithAppleMutation } from 'shared/hooks/queries/use-login-user-with-apple-mutation';

export const useLoginWithApple = () => {
  const { mutateAsync, error, reset, isPending } =
    useLoginUserWithAppleMutation();

  const login = useCallback(async () => {
    try {
      await mutateAsync();
    } catch {
      // the mutation's `error` state carries the failure the page shows
    }
  }, [mutateAsync]);

  return { login, error: error?.kind, reset, isLoading: isPending };
};
